import { Component, OnInit, ViewEncapsulation, OnDestroy, DoCheck, Input } from "@angular/core";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { AppSettings } from "../../../app.settings";
import { Settings } from "../../../app.settings.model";
import { MenuService } from "../menu/menu.service";
import { CustomerService } from "src/app/services/customer.service";
import { Subscription, combineLatest } from "rxjs";
import { WebCompany, WebCustomer, WebSettings } from "src/app/models";
import { ContractsService } from "../../../services/contracts.service";
import { Menu } from "../menu/menu.model";
import { CompanyService } from "../../../services";
import { SessionDataService } from "src/app/services/session-data.service";
import { CompanyClient } from "src/app/models";
import { first } from "rxjs/operators";
import { filter } from "rxjs/operators";


@Component({
    selector: "app-sidenav",
    templateUrl: "./sidenav.component.html",
    styleUrls: ["./sidenav.component.scss"],
    encapsulation: ViewEncapsulation.None,
    providers: [MenuService],
})
export class SidenavComponent implements OnInit, OnDestroy
{
    public psConfig: PerfectScrollbarConfigInterface = {
        wheelPropagation: true,
    };

    @Input() isCompany: boolean;

    public menuItems: Menu[];
    public settings: Settings;
    public isPrebuyAvailable: boolean;
    public areMenuChecksFinished: boolean = false; 
    public isCustomerSearchActive: boolean = false;
    isEquipmentAvailable: boolean;
    areTransactionsAvailable: boolean;
    isSWOAvailable: boolean;
    isDeliveryAvailable: boolean;
    areContractsAvailable: boolean;
    isImagingAvailable: boolean;
    isArchiveAvailable: boolean;
    private subscriptions = new Subscription();
    public customer: WebCustomer;
    public company: WebCompany;
    public canSearch: boolean;

    public isCustSelected: boolean = false;


    constructor(
        public appSettings: AppSettings,
        public menuService: MenuService,
        private customerService: CustomerService,
        private sessionDataService: SessionDataService,
        private contractService: ContractsService,
        private companyService: CompanyService,
        private companyClient: CompanyClient
    ) 
    {
        this.settings = this.appSettings.settings;
    }

    ngOnInit() 
    {
        const menuSubscription = this.menuService.menuItems.subscribe(m =>
        {
            this.menuItems = m;
        });
        this.subscriptions.add(menuSubscription);
        const customerSubscription = this.customerService.customer.subscribe(customer =>
        {
            this.customer = customer;
            this.isCustSelected = !!customer?.CustId;
            this.isCustomerSearchActive = !this.isCustSelected;
            const combinedSubscription = combineLatest([
                this.companyService.company,
                this.companyClient.getAppStartup(this.sessionDataService.DataLogical, customer.BranchNo),
                this.contractService.prebuySwitch,
                this.companyService.webSettings
            ])
                .subscribe(([company, appStartup, prebuySwitch, webSettings]) =>
                {
                    this.isEquipmentAvailable = company.WebDisplayEquipment ?? false;
                    this.areTransactionsAvailable = company.WebDisplayTransactions ?? false;
                    this.isSWOAvailable = company.ShowService ?? false;
                    this.isDeliveryAvailable = company.ShowDelivery ?? false;

                    this.isArchiveAvailable = appStartup.CompanyInterfaces?.IsArchiveAvailable ?? false;
                    this.isPrebuyAvailable = prebuySwitch;
                    this.areContractsAvailable = webSettings.AreContractsEnabled ?? true;
                    this.isImagingAvailable = webSettings.IsImagingEnabled ?? false;

                    this.checkMenuItems();
                });

            this.subscriptions.add(combinedSubscription);
        });

        this.subscriptions.add(customerSubscription);

        this.canSearch = this.sessionDataService.IsEmployee;
    }

    ngOnDestroy() 
    {
        this.subscriptions.unsubscribe();
    }

    public checkMenuItems(): void
    {
        if (!this.isCompany)
        {
            const idsToRemove: number[] = [];

            if (this.isPrebuyAvailable === false) idsToRemove.push(8);
            if (this.isEquipmentAvailable === false) idsToRemove.push(3);
            if (this.areTransactionsAvailable === false) idsToRemove.push(2);
            if (this.isSWOAvailable === false) idsToRemove.push(10);
            if (this.isDeliveryAvailable === false) idsToRemove.push(11);
            if (this.areContractsAvailable === false) idsToRemove.push(7);
            if (this.isArchiveAvailable === false || this.isImagingAvailable === false) idsToRemove.push(12);

            this.menuItems = this.menuItems.filter(item => !idsToRemove.includes(item.id));
        }
        this.areMenuChecksFinished = true;
    }

    public closeSubMenus() 
    {
        const menu = document.getElementById("vertical-menu");
        if (menu) 
        {
            for (let i = 0; i < menu.children[0].children.length; i++)
            {
                let child = menu.children[0].children[i];
                if (child)
                {
                    if (child.children[0].classList.contains("expanded"))
                    {
                        child.children[0].classList.remove("expanded");
                        child.children[1].classList.remove("show");
                    }
                }
            }
        }
    }

    public onMenuItemClicked(menuId: number): void
    {
        if (this.isCompany && menuId === 0)
        {
            this.isCustomerSearchActive = true;
        }
    }

}